<div class="mat-dialog-content confirm">
  <span class="confirm-icon">
    <mat-icon>help_outline</mat-icon>
  </span>
  <h2 class="confirm-title">{{ title }}</h2>
  <p class="confirm-text" [innerHTML]="message"></p>
</div>

<div mat-dialog-actions align="center">
  <button mat-stroked-button (click)="onDismiss()">Não</button>
  <button mat-flat-button color="primary" (click)="onConfirm()">Sim</button>
</div>
